// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-v-select[data-v-41a12af9] {\n  background: white !important;\n}\n.custom-v-select[data-v-41a12af9] .vs__dropdown-menu {\n  width: auto !important;\n  min-width: 100% !important;\n}", ""]);
// Exports
module.exports = exports;
